export enum ReleaseNoteChangeTypeIdEnum {
  BugFix = 1,
  Feature = 2
}
